// The referral code a browser carries to sign-in (G1, cold start) — with the
// owner's rulings of 2026-09-21:
//
//   · FIRST LINK WINS. The first ?ref= / ?affiliate_code= this browser sees is
//     the one that counts. (It used to be the LAST: each click overwrote the
//     saved code, so a referrer's link could be silently replaced by an
//     affiliate's clicked a day later.)
//   · LATER LINKS ARE REMEMBERED, NOT CREDITED. They ride along to the server
//     only so they can be logged (referral_link_attempts) — the audit trail
//     that answers "I gave that person my link". The server still applies its
//     own first-code-wins across devices; this is the same rule, per browser.
//   · A WATER COOLER GUEST LINK IS NOT A REFERRAL LINK and never writes here.
//
// Shape in localStorage["glonet_ref"]:
//   { code, post, ts, later: [{ code, post, ts }] }   (ts = ms, when seen)
// Older browsers hold { code, post, ts } — read as "no later links".
const KEY = "glonet_ref";
const MAX_LATER = 20;

const norm = (c) => String(c || "").trim().toUpperCase();

export function readBanked() {
  try {
    const b = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!b || !b.code) return null;
    return { code: b.code, post: b.post || null, ts: b.ts || null, later: Array.isArray(b.later) ? b.later : [] };
  } catch (e) { return null; }
}

// Record a referral link this browser just opened. Returns what is now banked.
export function bankReferral(code, post) {
  const c = norm(code);
  if (!c || c.length > 64) return readBanked();
  const now = Date.now();
  const cur = readBanked();
  let next;
  if (!cur) {
    next = { code: c, post: post || null, ts: now, later: [] };
  } else if (norm(cur.code) === c || cur.later.some((l) => norm(l.code) === c)) {
    next = cur; // already known: the first sighting is the one that counts
  } else {
    next = { ...cur, later: [...cur.later, { code: c, post: post || null, ts: now }].slice(0, MAX_LATER) };
  }
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* storage off */ }
  return next;
}

// What POST users/referral takes: the first link, plus the later ones to log.
export function claimPayload(b) {
  if (!b || !b.code) return null;
  const pid = (p) => (p ? Number(p) || null : null);
  return {
    code: b.code, post_id: pid(b.post), clicked_at: b.ts || null,
    later: (b.later || []).map((l) => ({ code: l.code, post_id: pid(l.post), clicked_at: l.ts || null })),
  };
}

export const clearBanked = () => { try { localStorage.removeItem(KEY); } catch (e) { /* storage off */ } };
